import React, { Component } from 'react';
import axios from "axios";

import SpinnerModal from '@components/SpinnerModal';
import BarChartWidget from '@components/BarChartWidget';
import TableWidget from '@components/TableWidget';
import ResearcherDashboardService from '@services/ResearcherDashboardService';
import RolePermissionManagementService from "@services/RolePermissionManagementService";

import styles from './dashboard.module.css';

class Dashboard extends Component {
  state = {
    loading: false,
    correspondentsOverallProgress: [],
    correspondentsCompletedSurveys: [],
  }

  async componentDidMount() {
    this.setState({ loading: true });

    /* The `parseJwt` function is a helper function that takes a JWT token as input and returns the
    payload of the token as a JavaScript object. It is used to extract the payload from the JWT
    token stored in the local storage. */
    function parseJwt(token) {
      const base64Payload = token.split('.')[1];
      const payload = atob(base64Payload);
      return JSON.parse(payload.toString());
    }


    let bearer = localStorage.getItem('Bearer');

    if (!bearer) {
      window.location = "/login";

    }

    let payload = parseJwt(bearer);

    let orgID = payload.org_id;
    let sector_id = payload.sector_id;
    let surveycycle = process.env.REACT_APP_CURRENT_SURVEY_CYCLE;

    await (async () => {
      await RolePermissionManagementService.initialiseRolesAndPermissions(payload.user_id);
    })([]);

    const researcherCorrespondentsStatus = await (async () => {
      const result = await ResearcherDashboardService.getCorrespondentsStatus(process.env.REACT_APP_CURRENT_SURVEY_CYCLE);
      return result;
    })([]);
    this.setState({ correspondentsOverallProgress: researcherCorrespondentsStatus });

    let researcherCompletedSurveys = process.env.REACT_APP_RESEARCHER_DASHBOARD_MICROSERVICE_URL + process.env.REACT_APP_SERVICES_VERSION + `/researcherdashboardservice/completedsurveys/surveycycle/${surveycycle}`;
    let researcherCompletedSurveysURL = axios.create({ baseURL: researcherCompletedSurveys });

    researcherCompletedSurveysURL.get('').then(
      resp => {
        const respData = resp.data;

        let completedSurveys = [];
        if (respData.status === "SUCCESS") {
          respData.response.success.forEach(record => {
            completedSurveys.push(record);
          });
        }

        this.setState({
          correspondentsCompletedSurveys: completedSurveys,
        });

      }
    );

    let organisationNameUrl = process.env.REACT_APP_SURVEY_MICROSERVICE_URL + process.env.REACT_APP_SERVICES_VERSION + "/questionnaireservice/questionnairetrackers/organisation/name/" + orgID;
    let sectorNameUrl = process.env.REACT_APP_SURVEY_MICROSERVICE_URL + process.env.REACT_APP_SERVICES_VERSION + "/questionnaireservice/questionnairetrackers/sector/name/" + sector_id;

    if (orgID) {

      axios.get(organisationNameUrl)
        .then(response => {
          localStorage.setItem('organisationName', response.data.name);
        });
    }

    if (sector_id) {

      axios.get(sectorNameUrl)
        .then(response => {
          localStorage.setItem('sectorName', response.data.name);
        });
    }

    this.setState({ loading: false });
  }

  render() {
    if (this.state.loading === true) {
      return <SpinnerModal settings={true} />
    } else {
      let latestCompletedSurveys = this.state.correspondentsCompletedSurveys;

      let columns = [
        { label: "Organisation", name: "Organisation" },
        { label: "Date Completed", name: "DateChecked" },
      ];

      return (
        <div className={styles.dashboard_overview_container}>
          <div className={styles.flex_row_container}>
            < TableWidget title="Latest Completed Surveys" rows={latestCompletedSurveys} columns={columns} />

            <BarChartWidget
              headerTitle="Overall Progress"
              dataLabel="Count"
              data={this.state.correspondentsOverallProgress}
              toolTip="Number of questionnaires started and not started by respondents"
            />
          </div >
        </div >
      )
    }
  }
}

export default Dashboard

